import { request } from '../../services/request';

export class HotSymbolsComponent {
    static $inject = ['$scope'];

    symbols: any[] = [];
    loading = true;

    constructor(private $scope: ng.IScope) {}

    async $onInit() {
        const { data } = await request('/api/v2.0/top-symbols');

        this.symbols = data;
        this.loading = false;
        this.$scope.$digest();
    }

    getSearchUrl(symbol: string) {
        return `/search?q=${encodeURIComponent('#') + symbol}#post`;
    }
}

angular.module('tradersyard').component('tyHotSymbols', {
    // language=HTML
    template: `
        <div class="hot_symbols">
            <div ng-if="$ctrl.loading" class="hot_symbols__info">
                <ty-loading-spinner/>
            </div>
            <div ng-if="!$ctrl.loading && $ctrl.symbols.length === 0" class="hot_symbols__info">
                No symbols found.
            </div>
            <div class="hot_symbols__symbol" ng-repeat="symbol in $ctrl.symbols track by symbol.name">
                <a ng-href="{{$ctrl.getSearchUrl(symbol.symbol)}}" open-authentication-dialog>{{symbol.symbol}} - {{symbol.name}}</a>
                <span class="hot_symbols__count">{{symbol.count}}</span>
            </div>
        </div>
    `,
    controller: HotSymbolsComponent,
});
